<template>
  <div class="regional-chart-container">
    <div class="filters">
      <select
        v-model="selectedState"
        class="filter-select"
      >
        <option value="">
          Todos os Estados
        </option>
        <option
          v-for="state in estados"
          :key="state"
          :value="state"
        >
          {{ state }}
        </option>
      </select>

      <input
        v-model="startDate"
        type="date"
        class="filter-select"
      >
      <input
        v-model="endDate"
        type="date"
        class="filter-select"
      >
    </div>

    <div class="chart-box">
      <bar-chart
        :chart-data="chartData"
        :options="chartOptions"
      />
    </div>
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs'
import { reactiveProp } from 'vue-chartjs/es/mixins'
import fetchReportData from '@/syslic/dashboard/reportService'
import filterEfficiencyData from '@/syslic/dashboard/efficiency/filterEfficiencyData'

export default {
  name: 'EfficiencyBarChart',
  components: {
    barChart: {
      extends: Bar,
      mixins: [reactiveProp],
      props: ['chartData', 'options'],
      mounted() {
        this.renderChart(this.chartData, this.options)
      },
      watch: {
        chartData(newData) {
          this.renderChart(newData, this.options)
        },
      },
    },
  },
  data() {
    return {
      rawData: [],
      estados: [],
      selectedState: '',
      startDate: '',
      endDate: '',
      chartData: {
        labels: [],
        datasets: [],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              id: 'y-oportunidades',
              position: 'left',
              ticks: { beginAtZero: true },
              scaleLabel: { display: true, labelString: 'Oportunidades' },
            },
            {
              id: 'y-tempo',
              position: 'right',
              ticks: { beginAtZero: true },
              scaleLabel: { display: true, labelString: 'Tempo médio (horas)' },
              gridLines: { drawOnChartArea: false },
            },
          ],
        },
        tooltips: { mode: 'index', intersect: false },
        legend: { position: 'top' },
      },
    }
  },
  watch: {
    selectedState() {
      this.loadData()
    },
    startDate() {
      this.loadData()
    },
    endDate() {
      this.loadData()
    },
  },
  async mounted() {
    await this.loadData()
  },
  methods: {
    async loadData() {
      // Se rawData vazio, busca dados da API
      if (!this.rawData.length) {
        this.rawData = await fetchReportData(this)
        const estadosUnicos = [...new Set(this.rawData.map(item => item.stateName).filter(Boolean))]
        estadosUnicos.sort()
        this.estados = estadosUnicos
      }

      // Filtrar por estado
      let filteredData = this.selectedState
        ? this.rawData.filter(item => item.stateName === this.selectedState)
        : [...this.rawData]

      // Filtrar por datas, apenas se as duas existirem
      if (this.startDate && this.endDate) {
        filteredData = filteredData.filter(item => {
          const itemDateStr = item.date ? item.date.split('T')[0] : null
          return itemDateStr && itemDateStr >= this.startDate && itemDateStr <= this.endDate
        })
      }

      const result = filterEfficiencyData(filteredData)

      const fases = ['SEM_INTERESSE', 'NAO_PARTICIPOU', 'NAO_GANHOU', 'DESCLASSIFICADO', 'GANHOS']
      const labels = fases.map(f => this.formatLabel(f))

      const oportunidades = fases.map(fase => result[fase] || 0)
      const tempos = fases.map(fase => {
        const t = result.tempos[fase]
        return t === 'N/A' ? 0 : parseFloat(t)
      })

      this.chartData = {
        labels,
        datasets: [
          {
            label: 'Oportunidades',
            backgroundColor: '#42A5F5',
            data: oportunidades,
            yAxisID: 'y-oportunidades',
          },
          {
            label: 'Tempo médio (horas)',
            backgroundColor: '#FFA726',
            data: tempos,
            yAxisID: 'y-tempo',
          },
        ],
      }
    },
    formatLabel(fase) {
      const labels = {
        SEM_INTERESSE: 'Sem Interesse',
        NAO_PARTICIPOU: 'Não Participou',
        NAO_GANHOU: 'Não Ganhou',
        DESCLASSIFICADO: 'Desclassificado',
        GANHOS: 'Ganhos',
      }
      return labels[fase] || fase.replace(/_/g, ' ')
    },
  },
}
</script>

<style scoped>
.filters {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
}

.filter-select {
  padding: 0.5rem;
  font-size: 1rem;
  border-radius: 0.25rem;
  border: 1px solid #ccc;
  max-width: 250px;
  width: 100%;
}

.chart-box {
  width: 100%;
  height: 400px;
}
</style>
